import { IProductRequest } from "../../Interfaces/IProductRequest"

export const getProductImages = (product: IProductRequest): string[] => {
  const configuredImages = product.images?.filter((image) => image.trim().length > 0) ?? []

  const fallbackImage = product.image?.trim()

  const availableImages = configuredImages.length > 0 ? configuredImages : fallbackImage ? [fallbackImage] : []

  return availableImages.filter((image, index) => availableImages.indexOf(image) === index)
}
